export default __webpack_public_path__ + "static/Dental-redesign-14a2efd23011e49ebe865cf5624bae36.png";